// startup
// Load entry module
__webpack_require__("./assets/scss/app.scss");
// This entry module used 'exports' so it can't be inlined
__webpack_require__("./assets/js/app.js");
